import { Pagination } from "react-admin";
import React from "react";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 250]} {...props} />
);

export default PostPagination;
